
export interface TableColumn {
  keyword: string;
  id?: number;
  title?: string;
  type?: TableColumnType;
  dateFormat?: string;
  sortableColumn?: any;
  isActionColumn?: boolean;
  columnClass?: string[];
  theadCellClass?: string | string[];
  tbodyCellClass?: string | string[];
}

export enum TableColumnType {
  index = 'index',

  text = 'text',

  number = 'number',

  date = 'date',

  url = 'url',

  img = 'img',

  projection = 'projection',

  inputCheckbox = 'inputCheckbox',

  inputAttachment = 'inputAttachment',

  inputText = 'inputText',

  inputNumber = 'inputNumber',

  inputRadiobutton = 'inputRadiobutton',

  inputTextarea = 'inputTextarea',

  inputSelect = 'inputSelect',

  inputDateRange = 'inputDateRange',

}

export enum IndexedDBTableName {
  advance_table_search = 'advance_table_search',
  translation = 'translation'
}
